export const state = {
    open: false
};

export const getters = {
    isSidebarOpen: ({ open }) => open
};

export const mutations = {
    SET_SIDEBAR_OPEN(state, value) {
        state.open = value;
    }
};
